"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.allReflexControllers = void 0;

var _attributes = require("./attributes");

// Returns StimulusReflex controllers local to the passed element based on the data-controller attribute.
//
var localReflexControllers = function localReflexControllers(app, element) {
  return (0, _attributes.attributeValues)(element.getAttribute(app.schema.controllerAttribute)).reduce(function (memo, name) {
    var controller = app.getControllerForElementAndIdentifier(element, name);
    if (controller && controller.StimulusReflex) memo.push(controller);
    return memo;
  }, []);
}; // Returns all StimulusReflex controllers for the passed element.
// Traverses DOM ancestors starting with element.
//


var allReflexControllers = function allReflexControllers(app, element) {
  var controllers = [];

  while (element) {
    controllers = controllers.concat(localReflexControllers(app, element));
    element = element.parentElement;
  }

  return controllers;
};

exports.allReflexControllers = allReflexControllers;